import styled from 'styled-components';
import { LoadingMaskSpinnerMixin } from '../../mixins/components/LoadingMaskMixin';
import { doNotForwardTransientProp } from '../../util/doNotForwardTransientProp';
export var StyledLoadingMaskSpinner = /*#__PURE__*/styled.div.withConfig({
  shouldForwardProp: doNotForwardTransientProp(['loading'])
}).withConfig({
  displayName: "StyledLoadingMaskSpinner",
  componentId: "c11n-8-107-0__sc-7w2q44-0"
})(["", ""], LoadingMaskSpinnerMixin);